import { render, staticRenderFns } from "./NarrativeTemplate.vue?vue&type=template&id=3236b160&"
import script from "./NarrativeTemplate.vue?vue&type=script&lang=js&"
export * from "./NarrativeTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeTemplate.vue?vue&type=style&index=0&id=3236b160&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports